<template>
  <div v-show="loginvis" class="loginBox">
    <guestLogin v-on:addUsertoUsers="addUsertoUsers" v-on:disable-form="changeshowlogin" v-on:adminid="adminid"
      v-bind:userData="userData" v-bind:adminUserData="adminUserData" />
  </div>
</template>

<script>
import guestLogin from "./guestLogin.vue";

export default {
  name: "Login",
  props: ["userData", "adminUserData"],
  components: {
    guestLogin,
  },
  data() {
    return {
      loginvis: true,
    };
  },
  methods: {
    changeshowlogin() {
      this.loginvis = false;
      this.$emit("userEmail");
    },
    adminid() {
      this.$emit("adminid");
    },
    addUsertoUsers() {
      this.$emit("addUsertoUsers");
    },
  },
};
</script>

<style>
.loginBox {
  padding: 20px !important;
  position: absolute;
  z-index: 12 !important;
  background-color: white;
  height: 400px;
  width: 320px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border-radius: 5px;
  box-shadow: 0 35px 14px -22px rgba(0, 0, 0, 0.5);
  bottom: -40px !important;
  z-index: 1 !important;
  -webkit-transition: all 0.2s ease-out;
  -moz-transition: all 0.2s ease-out;
  -o-transition: all 0.2s ease-out;
  transition: all 0.2s ease-out;
}
</style>
